import { RiFeedbackLine } from '@remixicon/react';
import { useState } from 'react';
import { DrawerId, useSideDrawer } from 'src/components/containers/SideDrawer';
import { AgButton } from 'src/components/ui';
import { captureFeedbackContext } from './FeedbackDrawer';

export function FeedbackButton() {
  const { openDrawer } = useSideDrawer();
  const [capturing, setCapturing] = useState(false);

  const open = async () => {
    setCapturing(true);
    const context = await captureFeedbackContext(window.location.pathname);
    setCapturing(false);
    openDrawer(DrawerId.CUSTOMER_FEEDBACK, context);
  };

  return (
    <AgButton variant="ghost" isDisabled={capturing} onPress={open}>
      <RiFeedbackLine size={18} /> Feedback
    </AgButton>
  );
}
